<template>
  <b-container ref="mainContainer">
    <b-form @submit.prevent="onSubmit">
      <b-row>
        <h3>Ustawienia poczty</h3>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group class="required" label="Login">
            <b-form-input
              v-model="login"
              type="text"
              autocomplete="off"
              :state="$v.login.$error? false : null"
              @input="$v.login.$reset()"
            />
            <b-form-invalid-feedback>To pole jest wymagane</b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col align-self="center">
          <b-form-checkbox v-model="changePassword" switch>Zmień hasło</b-form-checkbox>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group class="required" label="Email">
            <b-form-input
              v-model="email"
              type="text"
              autocomplete="off"
              :state="$v.email.$error? false : null"
              @input="$v.email.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.email.email">Niepoprawny adres email</div>
              <div v-if="!$v.email.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group class="required" label="Hasło" v-if="changePassword">
            <b-form-input
              v-model="password"
              :type="passwordType"
              :state="$v.password.$error? false : null"
              @input="$v.password.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.password.required">To pole jest wymagane</div>
              <div v-if="!$v.password.sameAsConfirmPassword">Hasła muszą być takie same</div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group class="required" label="Host">
            <b-form-input
              v-model="host"
              type="text"
              autocomplete="off"
              :state="$v.host.$error? false : null"
              @input="$v.host.$reset()"
            />
            <b-form-invalid-feedback>To pole jest wymagane</b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group class="required" label="Potwierdź hasło" v-if="changePassword">
            <b-form-input
              v-model="confirmPassword"
              :type="passwordType"
              :state="$v.confirmPassword.$error? false : null"
              @input="$v.confirmPassword.$touch()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.confirmPassword.required">To pole jest wymagane</div>
              <div v-if="!$v.confirmPassword.sameAsPassword">Hasła muszą być takie same</div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group class="required" label="Port">
            <b-form-input
              v-model="port"
              type="number"
              autocomplete="off"
              :state="$v.port.$error? false : null"
              @input="$v.port.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.port.minValue">Wartość nie może być ujemna</div>
              <div v-if="!$v.port.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-checkbox v-model="SSLEnabled" switch>Szyfrowanie SSL</b-form-checkbox>
        </b-col>
      </b-row>

      <b-row>
        <b-col offset-md="6">
          <b-form-group>
            <b-button
              class="float-right"
              type="submit"
              variant="primary"
              :disabled="loading"
              @click="$v.$touch"
            >
              <span v-show="!loading">Edytuj</span>
              <span v-show="loading">
                <b-spinner small label="Loading..."></b-spinner>
              </span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, email, sameAs, minValue } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      host: "",
      port: null,
      email: "",
      login: "",
      password: "",
      confirmPassword: "",
      SSLEnabled: false,

      changePassword: false,
      hidePassword: true,
      loading: false
    };
  },
  validations() {
    if (this.changePassword) {
      return {
        host: {
          required
        },
        port: {
          required,
          minValue: minValue(0)
        },
        email: {
          required,
          email
        },
        login: {
          required
        },
        password: {
          required,
          sameAsConfirmPassword: sameAs("confirmPassword")
        },
        confirmPassword: {
          required,
          sameAsPassword: sameAs("password")
        }
      };
    } else {
      return {
        host: {
          required
        },
        port: {
          required,
          minValue: minValue(0)
        },
        email: {
          required,
          email
        },
        login: {
          required
        }
      };
    }
  },
  mounted() {
    this.loading = true;
    let loader = this.$loading.show({
      container: this.$refs.mainContainer
    });

    axios
      .get("/settings/email")
      .then(response => {
        this.host = response.data.host;
        this.port = response.data.port;
        this.email = response.data.email;
        this.login = response.data.login;
        this.SSLEnabled = response.data.sslEnabled;
      })
      .catch(error => eventBus.$emit("unhandled-error", error))
      .then(() => {
        this.loading = false;
        loader.hide();
      });
  },
  computed: {
    passwordType() {
      return this.hidePassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hidePassword ? "eye" : "eye-slash";
    }
  },
  methods: {
    onSubmit() {
      if (!this.$v.$error) {
        let loader = this.$loading.show({
          container: this.$refs.mainContainer
        });

        axios
          .post("/Settings/email", {
            host: this.host,
            port: this.port,
            email: this.email,
            login: this.login,
            password: this.changePassword ? this.password : null,
            confirmPassword: this.changePassword ? this.confirmPassword : null,
            SSLEnabled: this.SSLEnabled
          })
          .then(() => {
            this.changePassword = false;
            this.password = "";
            this.confirmPassword = "";
            eventBus.$emit("notify-success", "Dane zostały poprawnie zapisane");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => loader.hide());
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>
